import Grid from '@mui/material/Grid';
import React from 'react';
import { useCurrentOrganisation } from '../../../../../../app/CurrentOrganisationProvider';
import { DataErrorHandler, ErrorHandler } from '../../../../../../components/ErrorHandler';
import { Loading, Workspace } from '../../../../../../design-system';
import { locationHasAttributes } from '../../../../../../utils/format';
import { useChargePoint } from '../Provider';
import { ConnectorList } from './components/ConnectorList';
import { Header } from './components/Header';
import { RecentSessions } from './components/RecentSessions';
import { ReloadButton } from './components/ReloadButton';

export const OverviewView: React.FC = () => {
  const {
    chargePoint,
    error: errorGettingChargePoint,
    loading: chargePointLoading,
    refetch: refetchChargePoint,
  } = useChargePoint();
  const { organisation, loading: organisationLoading } = useCurrentOrganisation();

  if (chargePointLoading || organisationLoading) {
    return (
      <Workspace>
        <Loading />
      </Workspace>
    );
  }

  if (errorGettingChargePoint || !chargePoint) {
    return (
      <DataErrorHandler
        description="Unable to load charge point"
        error={errorGettingChargePoint}
        refetch={refetchChargePoint}
      />
    );
  }

  if (!organisation) {
    return (
      <Workspace>
        <ErrorHandler title="Unable to load organisation" />
      </Workspace>
    );
  }

  const location = locationHasAttributes(chargePoint.location) ? chargePoint.location : undefined;

  return (
    <Workspace maxWidth={false}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Header
            chargePoint={chargePoint}
            organisation={organisation}
            location={location}
            loadManagement={chargePoint.profiles.loadManagement}
          />
        </Grid>
        <Grid item xs={12}>
          <RecentSessions chargePoint={chargePoint} organisation={organisation} />
        </Grid>
        <Grid item xs={12}>
          <ConnectorList chargePoint={chargePoint} refetch={refetchChargePoint} />
        </Grid>
        <ReloadButton loading={chargePointLoading} refetch={refetchChargePoint} />
      </Grid>
    </Workspace>
  );
};
